import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { InvoiceDetailsData } from '../../models/Invoice';

const URL = '/api/v1/invoices/';

const useInvoiceProductsSWR = (invoiceId: string) => {
    const productsUrl = URL + invoiceId;
    const fetch = (query): Promise<InvoiceDetailsData> => {
        return httpApi
            .get<{ invoice: InvoiceDetailsData }>(query)
            .then((res) => {
                return res.getData().invoice;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(productsUrl, fetch, {
        dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
    });

    const convertData = (data) => {
        return data;
    };

    const countItems = (data) => {
        return data.filter((elem) => elem.lineType == 'Item').length;
    };

    return {
        products: data ? convertData(data) : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
        productNumber: data ? countItems(data) : 0,
    };
};

export default useInvoiceProductsSWR;
